module.exports = __webpack_public_path__ + "images/ea900b33d647116915eb322a5bbc1e6e-IMG_8208.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/kitchen/IMG_8208.jpg
// module id = ./src/assets/images/slides/kitchen/IMG_8208.jpg
// module chunks = 0